export class SupervisorUpdate {
    PortalOperatorID: string;
    CompanyID: number;
    PublicInstitutionID: number;
    Email: string;
    FirstName: string;
    LastName: string;
    Password: string;
    Phone: string;

    // Constructors
    constructor(
        portalOperatorID: string,
        companyID: number,
        publicInstitutionID: number,
        email: string,
        firstName: string,
        lastName: string,
        password: string,
        phone: string,
    ) {
        this.PortalOperatorID = portalOperatorID;
        this.CompanyID = companyID;
        this.PublicInstitutionID = publicInstitutionID;
        this.Email = email;
        this.FirstName = firstName;
        this.LastName = lastName;
        this.Password = password;
        this.Phone = phone;
    }
}